import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";

/**
 * Gets all selected Valuation Events if asked for it
 */
export class GetAllSelectedPortfoliosGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'getAllSelectedPortfolios');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const allValuationEvents = this.workspace.grid.getFlattenGridDataResultData();
    const checkedValuationEvents = allValuationEvents.filter(ve => ve.checkbox);

    this.eventBus.broadcastEvent('allSelectedPortfolios', checkedValuationEvents);
  }
}
